import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';
import { GtmItemCategory } from '@app/domain/model/gtm/GtmItemCategory';
import { HomeInsuranceRiskPackage } from '@app/domain/model/eshop/home/HomeInsuranceRiskPackage';
import { ProductDataRider } from '@app/domain/model/eshop/transport/ProductDataRider';
import { TransportOffer } from '@app/domain/model/eshop/transport/TransportOffer';

export interface HomeProposalCalculatedData {
    offers: TransportOffer;
    selectedRisk: Nullable<HomeInsuranceRiskPackage>;
    selectedRiders: ProductDataRider[];
}

export function trackProposalCalculated(data: HomeProposalCalculatedData): void {
    const totalPrice = data.offers.priceToPayNow ?? 0;
    const firstPolicy = data.offers.policies[0];

    const items: EcommerceItem[] = [];

    if (data.selectedRisk) {
        const riskPrice = data.selectedRisk.premiumAfterDiscount ?? data.selectedRisk.premium ?? 0;

        if (riskPrice > 0) {
            items.push({
                item_name: data.selectedRisk.name,
                item_id: data.selectedRisk.code,
                price: riskPrice,
                item_category: GtmItemCategory.HomeInsurance,
                quantity: 1,
            });
        }
    }

    data.selectedRiders.forEach(rider => {
        if (rider.riderGuid && rider.premiums.premium > 0) {
            items.push({
                item_name: rider.riderName,
                item_id: rider.riderGuid,
                price: rider.premiums.premium,
                item_category: GtmItemCategory.Rider,
                quantity: 1,
            });
        }
    });

    pushEcommerceEvent(GtmEventName.ProposalCalculated, {
        currency: 'EUR',
        value: totalPrice,
        offer_number: firstPolicy?.offerNumber,
        items,
    });
}
